<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-claim-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewClaim',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewClaimView: () => import('../components/core/ViewClaimView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
